/*
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-11-22 18:39:16
 * @LastEditors: guanbowen 
 * @LastEditTime: 2023-03-19 22:21:43
 */
const parentRouter = [
  {
    label: '合同菜单',
    path: ''
  }
]
const routes = [
  {
    path: '/contractManage',
    name: 'contractManage',
    meta: {
      title: '合同管理',
      icon: 'icon-guanyu',
      noAuth: true,
      parentTitle: parentRouter
    },
    component: () => import('@main/modules/contractManage/views/contract.vue')
  },
  {
    path: '/openAccount',
    name: 'openAccount',
    meta: {
      title: '申报开户',
      icon: 'icon-guanyu',
      noAuth: true,
      parentTitle: parentRouter
    },
    component: () => import('@main/modules/contractManage/views/openAccount.vue')
  },
]
export default routes
